import { useState, useCallback } from "react";
import config from "../config";

const PLACEHOLDER_IMGS = [
  "https://placehold.co/600x240/3d3d3d/888?text=Image+1",
  "https://placehold.co/600x240/3d3d3d/888?text=Image+2",
  "https://placehold.co/600x240/3d3d3d/888?text=Image+3",
];

// resolves /api/ prefixed urls to full backend urls
const resolveUrl = (src) =>
  src?.startsWith("/api/") ? `${config.apiUrl}${src.slice(4)}` : src;

export function useCarousel(rawImages) {
  const srcs = (rawImages?.length ? rawImages : PLACEHOLDER_IMGS).map(resolveUrl);
  const [idx, setIdx] = useState(0);
  const [lightboxUrl, setLightboxUrl] = useState(null);

  const prev = useCallback((e) => {
    e.stopPropagation();
    setIdx((i) => Math.max(0, i - 1));
  }, []);

  const next = useCallback((e) => {
    e.stopPropagation();
    setIdx((i) => Math.min(srcs.length - 1, i + 1));
  }, [srcs.length]);

  const goTo = useCallback((e, i) => {
    e.stopPropagation();
    setIdx(i);
  }, []);

  const openLightbox = useCallback((e) => {
    e.stopPropagation();
    setLightboxUrl(srcs[idx]);
  }, [srcs, idx]);

  const closeLightbox = useCallback(() => setLightboxUrl(null), []);

  return {
    images: srcs,
    idx,
    hasMultiple: srcs.length > 1,
    prev,
    next,
    goTo,
    lightboxUrl,
    openLightbox,
    closeLightbox,
  };
}
